import type { TimelineExitKind } from './types';

/** The muted words after a repeated exit name; null when the glyph says enough. */
export const exitLabel = (
  kind: TimelineExitKind | null,
  to: string | null
): string | null => {
  switch (kind) {
    case 'sold':
      return to === null ? null : `to ${to}`;
    case 'jv':
      return 'joint venture';
    case 'independent':
      return 'independent';
    case 'listed':
      return 'listed';
    default:
      return null;
  }
};
